// extracted by mini-css-extract-plugin
export default {"Slices":"slices_Slices__1rkm8"};